import { gql } from '@apollo/client';
import { NSC_PROGRESSION_DATA } from '../fragments';

export const FILTERED_NSC_PROGRESSION = gql`
  query FilteredNSCProgression($input: SearchData!) {
    progressions: filteredNSCProgressionDatas(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...nscProgressionData
        }
      }
    }
  }
  ${NSC_PROGRESSION_DATA}
`;
